import { featureFlags } from "#/config/featureFlags";
import { ButtonFeatureFlag } from "#/types/featureFlags";

import { useFeatureFlags } from "./useFeatureFlags";

export const useTransferButtonFeatureFlag = () => {
  const featureFlag = useFeatureFlags<ButtonFeatureFlag>(
    featureFlags.transferButton,
  );
  const isTransferButtonEnabled = featureFlag?.isEnabled ?? true;
  const transferButtonTitle = featureFlag?.title ?? "Transfer funds";
  const transferButtonTooltip = featureFlag?.tooltip;

  return {
    isTransferButtonEnabled,
    transferButtonTitle,
    transferButtonTooltip,
  };
};
